export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10284.42863df4.jpg";